exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmsInput {\n\tbackground-color: black;\n\tcolor: #f3bb45;\n\tfont-family: monospace;\n\tfont-size: 24px;\n\ttext-align: center;\n\tpadding-top: 0;\n\ttext-transform: uppercase;\n}\n.form-group {\n\tmargin-bottom: 0px;\n}\n.col-lg-11 {\n\tmargin-left: 0px;\n}\n\n.page-message__flash {\n\tmargin: 0 auto;\n\tmargin-top: 5px;\n\tmax-width: 25rem;\n}\n\n.page-message__flash-input {\n\tdisplay: inline-block;\n\tmax-width: 6rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/page-message/page-message.component.css
// module id = ../../../../../src/app/page-message/page-message.component.css
// module chunks = main